import { X, FileText } from 'lucide-react';
import { colors } from '../../styles/colors';
import ModalPortal from '../ModalPortal';

/**
 * PdfViewerModal - Modale d'affichage d'un PDF
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - État d'ouverture de la modale
 * @param {function} props.onClose - Callback de fermeture
 * @param {string} props.pdfUrl - URL du PDF à afficher
 * @param {string} [props.title='Aperçu de la facture'] - Titre de la modale
 */
function PdfViewerModal({ isOpen, onClose, pdfUrl, title = 'Aperçu de la facture' }) {
  if (!isOpen || !pdfUrl) return null;

  return (
    <ModalPortal>
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3000,
        fontFamily: '"Noto Sans", sans-serif'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: colors.text.white,
          borderRadius: '0.75rem',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
          width: '95%',
          maxWidth: '1200px',
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header PDF Viewer */}
        <div
          style={{
            padding: '1rem 1.5rem',
            borderBottom: `1px solid ${colors.secondary.lightGray}`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FileText size={20} color={colors.primary.teal} />
            <h3
              style={{
                margin: 0,
                fontSize: '1.125rem',
                fontWeight: '600',
                color: colors.primary.gray
              }}
            >
              {title}
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem',
              color: colors.secondary.mediumGray,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '0.375rem',
              transition: 'background-color 200ms'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = colors.secondary.lightGray;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <X size={24} />
          </button>
        </div>

        {/* PDF Iframe */}
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <iframe
            src={pdfUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title={title}
          />
        </div>
      </div>
    </div>
    </ModalPortal>
  );
}

export default PdfViewerModal;
